export const tags = ['SequenceOfUltrasoundRegions'];
